import { render, staticRenderFns } from "./pointsExchangeOrderManage.vue?vue&type=template&id=11caf4f4"
import script from "./pointsExchangeOrderManage.vue?vue&type=script&lang=js"
export * from "./pointsExchangeOrderManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports